import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Transaction } from '../../models/transaction.model';

@Component({
  selector: 'app-refund-modal',
  standalone: false,
  templateUrl: './refund-modal.component.html',
  styleUrl: './refund-modal.component.css'
})
export class RefundModalComponent {
  @Input() show = false;
  @Input() transaction!: Transaction;
  @Input() loading = false;

  @Output() close = new EventEmitter<void>();
  @Output() confirmRefund = new EventEmitter<{ uuid: string, type: 'full' | 'partial', amount?: number }>();

  refundType: 'full' | 'partial' = 'full';
  partialAmount: number | null = null;
  isInvalidAmount = false;

  checkPartialAmount() {
    const transactionAmount = parseFloat(this.transaction?.amount);
    this.isInvalidAmount =
      this.partialAmount != null &&
      !isNaN(transactionAmount) &&
      this.partialAmount > transactionAmount;
  }

  submit() {
    if (this.loading) {
      return;
    }

    if (this.refundType === 'partial') {
      this.checkPartialAmount();

      if (this.isInvalidAmount || !this.partialAmount || this.partialAmount <= 0) {
        return;
      }

      this.confirmRefund.emit({ uuid: this.transaction.uuid, type: 'partial', amount: this.partialAmount });
    } else {
      this.confirmRefund.emit({ uuid: this.transaction.uuid, type: 'full' });
    }
  }
}
